module.exports = __webpack_public_path__ + "static/img/13.e78ea12.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/13.png
// module id = dnKW
// module chunks = 1